<template>
  <div>
    <h4 class="mt-4 mb-0">Variáveis</h4>

    <!-- {{ model }} -->

    <b-row v-if="!onlyCurrentForm">
      <b-col cols="6">
        <b-form-group label="Formulário" class="mt-2">
          <b-form-select
            id="geraAnomalia"
            class="select-boolean"
            :options="allForms"
            v-model="formId"
            @change="changeForm()"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <div v-for="variable in model.variables" :key="variable.id">
      <!-- {{ variable }} -->
      <b-row>
        <b-col cols="4" class="mt-2">
          <b-form-input
            class="input-name"
            type="text"
            v-model="variable.variableName"
            :disabled="true"
          />
        </b-col>
        <b-col
          cols="4"
          class="mt-2"
          v-if="variable.variableType == 1 || variable.currentForm == false"
        >
          <b-form-select
            id="geraAnomalia"
            class="select-boolean"
            :options="allForms"
            v-model="variable.formId"
            :disabled="true"
          ></b-form-select>
        </b-col>
        <b-col
          cols="4"
          class="mt-2"
          v-if="
            variable.currentForm == false &&
            formId != 0 &&
            variable.variableType == 0
          "
        >
          <b-form-select
            id="geraAnomalia"
            class="select-boolean"
            :options="getFormFieldsOpt(variable.fieldType)"
            v-model="variable.fieldName"
          ></b-form-select>
          <!-- {{ formFields }} -->
        </b-col>
        <b-col cols="4" class="mt-2" v-if="variable.currentForm">
          <b-form-select
            id="geraAnomalia"
            class="select-boolean"
            :options="getOptions(variable.fieldType)"
            v-model="variable.fieldName"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
    <!-- <div>{{ predefinedScript }}</div> -->
  </div>
</template>
<script>
export default {
  name: "PredefinedScriptForm",
  props: {
    predefinedScriptId: Number,
    script: String,
    fields: Array,
    model: Object,
  },
  created() {
    this.getPredefinedScript();
    this.getAllForms();
  },

  data() {
    return {
      predefinedScript: {},
      allForms: [],
      formFields: [],
      formId: 0,
      onlyCurrentForm: true,
    };
  },
  methods: {
    getAllForms() {
      this.$apiChecklist.get("/formulario/getAllForms/").then((response) => {
        this.allForms = response.data;
      });
    },
    async changeForm() {
      await this.getAllFormFields();
    },
    
    async getAllFormFields() {
      this.formFields = [];
      const response = await this.$apiChecklist.get(
        `/formulario/getAllFormFields/${this.formId}`
      );
      this.formFields = response.data;
      this.$forceUpdate();
    },

    getFormFieldsOpt(fieldType) {
      let opts = [];

      this.formFields.forEach((field) => {
        if (field.tipo == fieldType) {
          let opt = { value: field.nome, text: field.nome };
          opts.push(opt);
        } else if (field.tipo == 7 || field.tipo == 13) {
          field.valores.forEach((valor) => {
            if (valor.camposAdicionais.length > 0) {
              valor.camposAdicionais.forEach((campo) => {
                if (campo.tipo == fieldType) {
                  let opt = { value: campo.nome, text: campo.nome };
                  opts.push(opt);
                }
              });
            }
          });
        }
      });
      if (opts.length == 0) {
        opts.push({ value: "", text: "Nenhum campo do tipo encontrado" });
      }
      return opts;
    },

    getOptions(fieldType) {
      let opts = [];
      this.fields.forEach((field) => {
        if (field.item.tipo == fieldType) {
          let opt = { value: field.item.nome, text: field.item.nome };
          opts.push(opt);
        } else if (field.item.tipo == 7 || field.item.tipo == 13) {
          field.item.valores.forEach((valor) => {
            if (valor.camposAdicionais.length > 0) {
              valor.camposAdicionais.forEach((campo) => {
                if (campo.tipo == fieldType) {
                  let opt = { value: campo.nome, text: campo.nome };
                  opts.push(opt);
                }
              });
            }
          });
        }
      });
      return opts;
    },
    getPredefinedScript() {
      this.onlyCurrentForm = true;
      this.$apiChecklist
        .get("/predefinedScript/getById/" + this.model.predefinedScriptId)
        .then((response) => {
          this.predefinedScript = response.data;

          let predefined = {
            id: this.model.id,
            predefinedScriptId: this.model.predefinedScriptId,
            variables: [],
          };

          this.predefinedScript.variables.forEach((variable) => {
            let v = {
              id: 0,
              variableId: variable.id,
              variableName: variable.variableName,
              fieldName: "",
              formName: "",
              fieldType: variable.fieldType,
              currentForm: variable.currentForm,
              variableType: variable.variableType,
              formId: 0,
            };
            if (this.model != null) {
              if (
                this.model.variables != null &&
                this.model.variables.length > 0
              ) {
                this.model.variables.forEach((variableM) => {
                  if (variableM.variableId == variable.id) {
                    if (this.formId == 0) {
                      this.formId = variableM.formId;
                      this.changeForm();
                    }
                    v.id = variableM.id;
                    v.fieldName = variableM.fieldName;
                    v.formName = variableM.formName;
                    v.formId = variableM.formId;
                  }
                });
              }
            }

            if (v.currentForm == false) {
              this.onlyCurrentForm = false;
            }
            predefined.variables.push(v);
          });

          this.$emit("update:model", predefined);
          this.$emit("update:script", this.predefinedScript.script);
        });
    },
  },
  watch: {
    predefinedScriptId() {
      this.getPredefinedScript();
    },
    formId() {
      this.model.variables.forEach((variable) => {
        if (variable.currentForm == false) {
          variable.formId = this.formId;
        }
      });
      this.$forceUpdate();
    },
  },
};
</script>
